import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Shield } from "lucide-react";
import { api, isAdmin } from "@/lib/api";
import { useAuth } from "@/hooks/useAuth";

export default function AuthCallback() {
  const loc = useLocation();
  const nav = useNavigate();
  const [error, setError] = useState("");
  const { setUser } = useAuth();
  useEffect(() => {
    const id = new URLSearchParams(loc.hash.slice(1)).get("session_id");
    if (!id) return;
    api("/auth/session", { method: "POST", body: JSON.stringify({ session_id: id }) })
      .then(u => { setUser(u); nav(isAdmin(u) ? "/admin" : "/account", { replace: true }); })
      .catch(e => setError(e.message));
  }, [loc.hash, nav, setUser]);
  return (
    <main className="auth-callback" data-testid="auth-callback">
      <Shield size={42} />
      <h1>{error ? "Sign-in could not be completed" : "Signing you in"}</h1>
      <p data-testid="auth-callback-status">{error || "Please wait a moment…"}</p>
    </main>
  );
}
